import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { EnvironmentService, ErableHttpService } from '@ecm/consumer';

import { DeepLink } from '../business/deeplink/deeplink';

@Injectable({
    providedIn: 'root',
})
export class DeepLinkService {
    public constructor(
        private readonly environmentService: EnvironmentService,
        private readonly http: ErableHttpService,
    ) {}

    public getDeepLinkCode(code: string): Observable<DeepLink> {
        const env = this.environmentService.instant();
        return this.http.get(`${env.API.DEEP_LINK_URL}/${code}`, {}).pipe(map((response) => response as DeepLink));
    }
}
